import React from 'react';
import SvgIcon from '../SvgIconWrapper';

interface CalculatorIconProps {
  size?: number;
  color?: string;
  strokeWidth?: number | string;
}

const CalculatorIcon: React.FC<CalculatorIconProps> = ({ strokeWidth = 2, ...props }) => (
  <SvgIcon {...props} viewBox="0 0 50 50" className="sx-icon-calculator">
    <path
      d="M15 5.5 H35
         C38.59 5.5 41.5 8.41 41.5 12
         V38
         C41.5 41.59 38.59 44.5 35 44.5
         H15
         C11.41 44.5 8.5 41.59 8.5 38
         V12
         C8.5 8.41 11.41 5.5 15 5.5
         Z
         M15 12.5 H35 V19.5 H15 Z
         M16.5 24.5 H22.5 V30.5 H16.5 Z
         M25 24.5 H31 V30.5 H25 Z
         M33.5 24.5 H39.5 V30.5 H33.5 Z
         M16.5 33.5 H22.5 V39.5 H16.5 Z
         M25 33.5 H31 V39.5 H25 Z
         M33.5 33.5 H39.5 V39.5 H33.5 Z"
      fill="none"
      stroke={props.color || 'currentColor'}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);

export default CalculatorIcon;

